<template>
  <div class="bigEvent newEvent activity" :class="{floating: !inplace}"
       :style="inplace ? {} : {left: ev.position.left + 'px', top: ev.position.top + 'px'}">
  <v-form @submit.prevent="saveActivity" novalidate>
    <div class="event-header">
      <span class="event-date">{{ ev.datetime.date() }} <template v-if="$mq == 'sm'">({{ ev.datetime.format('ddd')}})</template></span>
      <span class="event-name">
        AKTYWNOŚĆ
      </span>
      <span class="event-actions">
        <v-icon dark class="click-effect ml-2" v-tooltip="'Zamknij'" @click.stop="$emit('close')">close</v-icon>
      </span>
    </div>
    <div class="event-content">
      <ul>
        <li>
          <v-textarea
              v-model="activity.runner_additional_info"
              label="Opis"
              :error="hasErrors('runner_additional_info')"
              :error-messages="getErrors('runner_additional_info')"
              auto-grow
              box
          >
            <i slot="prepend" v-tooltip="'Opis'" class="text-icon">O</i>
          </v-textarea>
        </li>
        <li>
          <v-text-field
              v-model="activity.total_distance_done"
              label="Dystans"
              :error="hasErrors('total_distance_done')"
              :error-messages="getErrors('total_distance_done')"
          >
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
          </v-text-field>
        </li>
      </ul>
      <div class="save-button-container">
        <v-btn small dark class="very-small" color="accent" type="submit">
          zapisz
          <v-icon right small >save</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="event-footer">
    </div>
  </v-form>
  </div>
</template>

<script>
import {createActivity, updateActivity} from './api'
import { mapGetters } from 'vuex'
import iziToast from 'izitoast'

export default {
  props: {
    ev: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: {},
      activity: {}
    }
  },
  computed: {
    ...mapGetters(['runner']),
    isNew () {
      return this.activity.id === undefined
    }
  },
  created () {
    this.initActivity()
  },
  methods: {
    initActivity () {
      this.activity = {...this.ev}
    },
    saveActivity () {
      if (this.isNew) {
        var promise = createActivity(this.runner, this.activity).then((data) => {
          this.$emit('created-activity', data)
          iziToast.show({
            message: 'Aktywność została dodana',
            color: 'green'
          })
          return data
        })
      } else {
        promise = updateActivity(this.runner, this.activity).then((data) => {
          this.$emit('updated-activity', data, this.ev)
          iziToast.show({
            message: 'Aktywność została zmieniona',
            color: 'green'
          })
          return data
        })
      }
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/ActivityForm.vue